import ApiService from '@/common/api.services'
import localStorageServices from '@/common/jwt.services'

import {
    SET_PAYMENTS,
    FETCH_PAYMENTS,
    FETCH_PAYMENT_AVAILIBILITY,
    CHECKOUT_PAYMENTS,
    INITIATE_FISERV_PAYMENT,
    FETCH_PAYMENT_STATUS,
    FETCH_ORDER_CONFIRMATION,
    SET_ORDER_CONFIRMATION,
    SET_PAYMENTS_STATUS,
    CHECKOUT_VOUCHER_PAYMENT,
    CHECKOUT_FLIGHT_PAYMENT,
    INITIATE_STRIPE_PAYMENT,
    CREATE_PAYMENT_INTENT
} from './actions.type'
const state = {
    allPayments: [],
    paymentStatus:[],
    confirmationStatus:[],

}

const getters = {
    allPayments(state) {
        return state
    },
    paymentStatus() {
        return state.paymentStatus;
      },
      confirmationStatus(){
        return state.confirmationStatus;
      }
    
}

const actions = {
  

    [FETCH_PAYMENTS](context , params) {
        return ApiService.getWithParams("/payments/user", { params })
            .then(({ data: { response: res } }) => {
                context.commit(SET_PAYMENTS, res);
                return res;
            })
            .catch((error) => {
                console.error(error);
                return error.response.status;
            });
    },
    [FETCH_PAYMENT_AVAILIBILITY](context, params) {
      return ApiService.getWithQueryParams('payment/available', params)
      .then(({ data: { response: res } }) => {
        return res;
      })
      .catch((error) => {
        console.error(error);
        return error.response.status;
      });
    },
    [CHECKOUT_PAYMENTS](context, params) {
        return ApiService.post('/payments/peachpayments/initiate', params)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error;
            });
    },
    [INITIATE_FISERV_PAYMENT](context, params) {
        return ApiService.post('/payments/fiserv/initiate', params)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error;
            });
    },
    [INITIATE_STRIPE_PAYMENT](context, params) {
        return ApiService.post('/payments/stripe/initiate', params)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error;
            });
    },
    [CREATE_PAYMENT_INTENT](context, params) {
        return ApiService.post('/payments/stripe/create-payment-intent', params)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error && error.response ? error.response.data : error;
            });
    },
   

      [FETCH_PAYMENT_STATUS]({ commit },{url, params}) {
        state.isLoading = true;
        return ApiService.getWithQueryParams(url, params)
          .then(({ data: { response: res } }) => {
            commit(SET_PAYMENTS_STATUS, res);
            state.isLoading = false;
            return res;
          })
          .catch((error) => {
            state.isLoading = false;
            console.error(error);
            return error.response.status;
          });
      },
      [FETCH_ORDER_CONFIRMATION]({ commit },props) {
        state.isLoading = true;
        return ApiService.get(props.url)
          .then(({ data: { response: res } }) => {
            commit(SET_ORDER_CONFIRMATION, res);
            state.isLoading = false;
            return res;
          })
          .catch((error) => {
            state.isLoading = false;
            console.error(error);
            return error.response.status;
          });
      },
      [CHECKOUT_VOUCHER_PAYMENT]({context}, {url , data}) {
        return ApiService.put(url , data)
          .then(response => {
            return response.data;
          })
          .catch(error => {
            return error.response.status;
          });
      },
      [CHECKOUT_FLIGHT_PAYMENT]({ context }, { url, data }) {
  return ApiService.put(url, data)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return error.response.status;
    });
}
}


const mutations = {
    [SET_PAYMENTS](state, res) {
        if (res.data.length) state.allPayments = res.data;
    },
     
    [SET_PAYMENTS_STATUS](state, res) {
        if (res.data.length) state.paymentStatus = res.data;
        state.isLoading = false;
      },
      [SET_ORDER_CONFIRMATION](state, res) {
        if (res.data.length) state.confirmationStatus = res.data;
        state.isLoading = false;
      },
}

export default {
    state,
    actions,
    mutations,
    getters
}
